// added time before/after clip (used for "extended" clip/fragment)
export const EXTENTION_IN_SECONDS = 5;

export const extendedClipOffset = (clipStart: number): number => {
  const realStartTime = clipStart - EXTENTION_IN_SECONDS > 0 ? clipStart - EXTENTION_IN_SECONDS : 0;
  return realStartTime;
};

export const extendedClipDuration = (clipStart: number, clipEnd: number, storyDuration: number): number => {
  const start = clipStart - EXTENTION_IN_SECONDS > 0 ? clipStart - EXTENTION_IN_SECONDS : 0;
  const end = clipEnd + EXTENTION_IN_SECONDS < storyDuration ? clipEnd + EXTENTION_IN_SECONDS : storyDuration;
  const clipExtendedDuration = end - start;
  return clipExtendedDuration;
};

export const extendedClipStart = (clipStart: number): number => {
  const start = clipStart - EXTENTION_IN_SECONDS > 0 ? EXTENTION_IN_SECONDS : clipStart;
  return start;
};

export const extendedClipEnd = (clipStart: number, clipEnd: number): number => {
  const start = extendedClipStart(clipStart);
  const duration = clipEnd - clipStart;
  return start + duration;
};

export const extendedClipTimeToStoryTime = (time: number): number => {
  const storyTime = time;
  return storyTime;
};

export const formatTime = (seconds: number): string => {
  if (isNaN(seconds)) {
    return "00:00";
  }
  const date = new Date(seconds * 1000);
  const hh = date.getUTCHours();
  const mm = date.getUTCMinutes().toString().padStart(2, "0");
  const ss = date.getUTCSeconds().toString().padStart(2, "0");
  if (hh) {
    return `${hh}:${mm}:${ss}`;
  }
  return `${mm}:${ss}`;
};

export const secondsToTimecode = (seconds: number): string => {
  if (isNaN(seconds)) {
    return "00:00:00";
  }
  const date = new Date(seconds * 1000);
  const hh = date.getUTCHours().toString().padStart(2, "0");
  const mm = date.getUTCMinutes().toString().padStart(2, "0");
  const ss = date.getUTCSeconds().toString().padStart(2, "0");

  return `${hh}:${mm}:${ss}`;
};
